<template lang="pug">
el-form.col-12(
    label-position='top',
    :model='formEdicaoContrato',
    :rules='formEdicaoContratoRegras',
    ref='formEdicaoContratoRef'
)
    .row
        el-form-item.col-3(label='Número do contrato', prop='numeroContrato')
            el-input(
                disabled,
                v-model.number='formEdicaoContrato.numeroContrato',
                maxlength='10'
            )

        el-form-item.col-2(label='Cultura', prop='cultura')
            el-select(
                v-model='formEdicaoContrato.cultura',
                clearable,
                filterable
            )
                el-option(
                    v-for='{ nome, id } in opcoes.culturas',
                    :key='id + nome',
                    :label='nome',
                    :value='id'
                )

        el-form-item.col-1(label='Safra', prop='safra')
            el-select(
                v-model='formEdicaoContrato.safra',
                clearable,
                filterable
            )
                el-option(
                    v-for='{ ano, id } in opcoes.safras',
                    :key='id + ano',
                    :label='ano',
                    :value='id'
                )

        el-form-item.col-3(label='Volume vendido (t)', prop='volumeContratado')
            el-input(
                v-model='formEdicaoContrato.volumeContratado',
                @blur='volumeContratadoFormatado'
            )

        el-form-item.col-3(label='Data do contrato', prop='dataContrato')
            el-date-picker(
                v-model='formEdicaoContrato.dataContrato',
                type='date',
                placeholder='Selecione',
                format='dd/MM/yyyy',
                :picker-options='pickerOptionsDataContrato'
            )

    .row
        el-form-item.col-1(label='UF entrega', prop='estado')
            el-select(
                v-model='formEdicaoContrato.estado',
                @change='buscarMunicipios(formEdicaoContrato.estado)',
                @clear='buscarMunicipios(formEdicaoContrato.estado)',
                clearable,
                filterable
            )
                el-option(
                    v-for='{ sigla, id } in opcoes.estados',
                    :key='id + sigla',
                    :label='sigla',
                    :value='id'
                )

        el-form-item.col-2(label='Município entrega', prop='municipio')
            el-select(
                v-model='formEdicaoContrato.municipio',
                :disabled='!formEdicaoContrato.estado',
                clearable,
                filterable
            )
                el-option(
                    v-for='{ nome, id } in opcoes.municipios',
                    :key='id + nome',
                    :label='nome',
                    :value='id'
                )

        el-form-item.col-3(label='Filial', prop='fornecedor')
            el-select(
                disabled,
                v-model='formEdicaoContrato.fornecedor',
                clearable,
                filterable
            )
                el-option(
                    v-for='fornecedor in opcoes.fornecedores',
                    :key='fornecedor.id + fornecedor.nome',
                    :label='fornecedor.nome',
                    :value='fornecedor'
                )

        el-form-item.col-3(label='Cliente', prop='cliente')
            el-select(
                v-model='formEdicaoContrato.cliente',
                value-key='id',
                clearable,
                filterable,
                @change='definirClienteDocumento'
            )
                el-option(
                    v-for='cliente in opcoes.clientes',
                    :key='cliente.id + cliente.nomeRazaoSocial',
                    :id='"cliente-" + cliente.id',
                    :label='cliente.nomeRazaoSocial',
                    :value='cliente'
                )

        el-form-item.col-3(label='CNPJ cliente', prop='clienteDocumento')
            el-select(
                v-model='formEdicaoContrato.clienteDocumento',
                :disabled='!formEdicaoContrato.cliente',
                placeholder='Selecione o CNPJ do cliente',
                clearable,
                filterable
            )
                el-option(
                    v-for='(documento, index) in formEdicaoContrato.cliente?.clienteDocumentos',
                    :key='documento.id',
                    :id='"clienteDocumento-" + index',
                    :label='documento.cpfCnpj',
                    :value='documento.id'
                )

    .row.row-btn-adicionar
        el-form-item.col-3(
            label='Número do contrato cliente',
            prop='codigoExterno'
        )
            el-input#numeroContrato(v-model='formEdicaoContrato.codigoExterno')

        el-form-item.col-3.botao
            el-button(
                type='primary',
                :disabled='editandoContrato',
                @click='salvarEdicao(formEdicaoContrato)'
            )
                i.el-icon.el-icon-plus
                | Salvar
</template>

<script>
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import formatters from '@/utils/formatters';

export default {
    name: 'FormEmpresaEditarContratoAlvorada',
    props: {
        opcoes: {
            type: Object,
            required: true
        },
        contrato: {
            type: Object,
            required: true
        }
    },
    watch: {
        contrato: function (newValue) {
            if (Object.values(newValue).length) {
                this.setFormEdicaoContrato();
            }
        }
    },
    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Campo obrigatório'));
                return;
            }

            if (value.toString().length !== 8) {
                callback(
                    new Error('O número do contrato deve conter 8 números')
                );
                return;
            }

            const apenasNumeros = /^\d*$/;
            if (!apenasNumeros.test(value)) {
                callback(
                    new Error('O número do contrato deve ser apenas números')
                );
                return;
            }

            if (value.toString().substr(0, 3) !== '400') {
                callback(
                    new Error('O número do contrato deve começar com "400"')
                );
                return;
            }

            callback();
        };

        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Campo obrigatório'));
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        'Não pode haver pontos, somente virgulas e números'
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(new Error('Número mal formatado'));
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(new Error('Valor não aceito'));
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(new Error('Valor deve ser maior que zero'));
                return;
            }

            callback();
        };

        return {
            formEdicaoContrato: {
                numeroContrato: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                dataContrato: '',
                estado: '',
                municipio: '',
                fornecedor: null,
                cliente: '',
                clienteDocumento: null,
                codigoExterno: ''
            },

            formEdicaoContratoRegras: {
                numeroContrato: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                estado: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'blur'
                    }
                ],
                municipio: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'blur'
                    }
                ],
                fornecedor: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                cliente: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'change'
                    }
                ],
                clienteDocumento: [
                    {
                        required: true,
                        message: 'Campo obrigatório',
                        trigger: 'blur'
                    }
                ],
                codigoExterno: [
                    {
                        required: false,
                        trigger: 'blur'
                    }
                ]
            },

            editandoContrato: false,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },
    methods: {
        setFormEdicaoContrato() {
            this.formEdicaoContrato.numeroContrato =
                this.contrato.numeroContrato;
            this.formEdicaoContrato.cultura = this.contrato.cultura;
            this.formEdicaoContrato.safra = this.contrato.safra;
            this.formEdicaoContrato.volumeContratado =
                this.contrato.volumeContratado;
            this.formEdicaoContrato.dataContrato = new Date(
                this.contrato.dataContrato
            );
            this.formEdicaoContrato.estado = this.contrato.estado;
            this.formEdicaoContrato.municipio = this.contrato.municipio;
            this.formEdicaoContrato.fornecedor = this.contrato.fornecedor;
            this.formEdicaoContrato.cliente = this.opcoes.clientes.find(
                c => c.id === this.contrato.clienteId
            );
            this.formEdicaoContrato.clienteDocumento =
                this.contrato.clienteDocumentoId;
            this.formEdicaoContrato.codigoExterno = this.contrato.codigoExterno;
        },
        async buscarMunicipios(idEstado) {
            this.formEdicaoContrato.municipio = '';
            if (idEstado) {
                this.$emit('buscarMunicipios', idEstado);
            }
        },
        definirClienteDocumento() {
            if (this.formEdicaoContrato.cliente) {
                this.formEdicaoContrato.clienteDocumento = '';
            }
        },
        salvarEdicao() {
            this.$refs['formEdicaoContratoRef'].validate(async valid => {
                if (valid) {
                    this.editandoContrato = true;
                    this.carregando = true;

                    ContratoOriginacaoServiceEmpresa.editarContrato({
                        id: this.contrato.id,
                        numeroContrato: this.formEdicaoContrato.numeroContrato,
                        idMaterial: this.formEdicaoContrato.cultura,
                        idSafra: this.formEdicaoContrato.safra,
                        volumeContratado: parseFloat(
                            this.formEdicaoContrato.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        valorDataContrato:
                            this.formEdicaoContrato.dataContrato.getTime(),
                        fornecedorParceiroId:
                            this.contrato.fornecedorParceiroId,
                        idSubEmpresa: this.contrato.subEmpresaId,
                        subEmpresaCnpj: this.contrato.cnpjFornecedor,
                        idSegmento: this.contrato.segmento,
                        idCanal: this.contrato.canal,
                        idRegional: this.contrato.regional,
                        idMunicipio: this.formEdicaoContrato.municipio,
                        idGerenteComercial: this.contrato.gerenteComercial,
                        idGestorTerritorial: this.contrato.gestorTerritorial,
                        idGerenteRegional: this.contrato.gerenteRegional,
                        idClienteDocumento:
                            this.formEdicaoContrato.clienteDocumento,
                        valorContrato: 0,
                        condicaoFrete: this.contrato.condicaoFrete,
                        localCondicaoFrete: this.contrato.localCondicaoFrete,
                        tipoContratoOffline: false,
                        codigoExterno: this.formEdicaoContrato.codigoExterno
                    })
                        .then(() => {
                            this.$notify.success(
                                `Contrato ${this.formEdicaoContrato.numeroContrato} alterado com sucesso!`
                            );

                            this.redirecionar();
                        })
                        .catch(error => {
                            if (
                                error.response.status === 405 ||
                                error.response.status === 400
                            ) {
                                this.$notify.error({
                                    message: error.response.data.message
                                });
                            } else {
                                this.$notify.error({
                                    message:
                                        'Ocorreu um erro ao editar, entre em contato com o administrador do sistema.'
                                });
                            }
                        })
                        .finally(() => {
                            this.carregando = false;
                        });
                } else {
                    this.$notify.warning(
                        'Todos os campos precisam estar preenchidos.'
                    );
                    return false;
                }
            });
        },
        volumeContratadoFormatado() {
            this.formEdicaoContrato.volumeContratado =
                formatters.formatarTonelada(
                    this.formEdicaoContrato.volumeContratado
                );
        },
        redirecionar() {
            this.editandoContrato = false;
            this.$router.push({ path: '/rastreabilidade/empresa' });
        }
    }
};
</script>

<style lang="scss">
.row.row-btn-adicionar {
    justify-content: space-between;
}

#editar-contrato-originacao {
    .editar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }
    .el-form-item__content {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        width: 100%;
    }
    .editar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }

        .el-card {
            border-radius: 15px;
        }

        .el-collapse-item {
            border-radius: 10px;
            overflow: hidden;
        }

        .el-collapse-item__content {
            padding: 0px;
        }

        .el-form-item {
            padding: 0 4px;
        }

        .el-select,
        .el-input,
        .el-date-picker,
        .el-button {
            width: 100%;
        }

        .row {
            align-items: flex-end;
            margin-bottom: 15px;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label::before,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:before {
            content: none !important;
            margin-right: 0px !important;
        }

        .el-form-item.is-required:not(.is-no-asterisk)
            > .el-form-item__label:after,
        .el-form-item.is-required:not(.is-no-asterisk)
            .el-form-item__label-wrap
            > .el-form-item__label:after {
            content: '*';
            color: #f56c6c;
            margin-left: 4px;
        }
    }
    .el-form-item.col-3.botao {
        display: flex;
        align-items: flex-end;
        justify-content: left;
    }
}
</style>
